export function anyToBoolean(value: any): boolean {
  if (typeof value === 'string') {
    return value.length !== 0 && value !== '0' && value.toLocaleLowerCase() !== 'false';
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'object') {
    return value !== null && !(Object.keys(value).length === 0 && value.constructor === Object);
  }

  return !!value;
}
